"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "reducerActionKeys", {
  enumerable: true,
  get: function get() {
    return _reducerActions2.reducerActionKeys;
  }
});
Object.defineProperty(exports, "ITrebleCore", {
  enumerable: true,
  get: function get() {
    return _interfaces.ITrebleCore;
  }
});
exports["default"] = void 0;

var _createModule = _interopRequireDefault(require("../../create-module/create-module"));

var _extendStore = _interopRequireDefault(require("./extend-store"));

var _renderComp = _interopRequireDefault(require("./render-comp"));

var _renderGuard = _interopRequireDefault(require("./middleware/render-guard"));

var _dispatchers = require("./dispatchers");

var _reducerActions2 = require("./reducer-actions");

var _interfaces = require("./interfaces");

var _reducerActions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TrebleCore = (0, _createModule["default"])({
  name: 'treble-core',
  extendStore: _extendStore["default"],
  renderComponent: _renderComp["default"],
  namespace: 'core',
  middleware: {
    check: _renderGuard["default"]
  },
  dispatchers: {
    'update': _dispatchers.update,
    'run': _dispatchers.run,
    'toggle': _dispatchers.toggle,
    'reset': _dispatchers.reset,
    'resetAll': _dispatchers.resetAll
  },
  reducerActions: (_reducerActions = {}, _defineProperty(_reducerActions, _reducerActions2.reducerActionKeys.update, _reducerActions2.updateState), _defineProperty(_reducerActions, _reducerActions2.reducerActionKeys.toggle, _reducerActions2.toggleState), _defineProperty(_reducerActions, _reducerActions2.reducerActionKeys.run, _reducerActions2.runSideEffect), _defineProperty(_reducerActions, _reducerActions2.reducerActionKeys.reset, _reducerActions2.resetToInitialState), _defineProperty(_reducerActions, _reducerActions2.reducerActionKeys.resetAll, _reducerActions2.resetAllToInitialState), _reducerActions)
});
var _default = TrebleCore;
exports["default"] = _default;